module.exports = __webpack_public_path__ + "src/assets/img/01_sf6.545eaf87.svg";